import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

export function isLevel1<Props extends object = {}>(
  Component: React.ComponentType<Props>
): React.FC<Props> {
  const Wrapper: React.FC<Props> = (props) => {
    const user = useUser();
    const role = (user?.role || "").toLowerCase();

    if (!["level 1", "accountant", "system admin"].includes(role)) {
      return <Navigate to="/onboarding/login" replace />;
    }
    return <Component {...props} />;
  };
  return Wrapper;
}
